import React from 'react';

export const ClearIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="#CBC9BF">
        <g>
          <path
            d="M22 14.8c-3.97 0-7.2 3.23-7.2 7.2s3.23 7.2 7.2 7.2 7.2-3.23 7.2-7.2-3.23-7.2-7.2-7.2zm3.394 8.897l-1.697 1.697L22 23.697l-1.697 1.697-1.697-1.697L20.303 22l-1.697-1.697 1.697-1.697L22 20.303l1.697-1.697 1.697 1.697L23.697 22l1.697 1.697z"
            transform="translate(-205 -292) translate(205 292)"
          />
        </g>
      </g>
    </g>
  </svg>
);
